import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { useForesight } from "@frontend/hooks/useForesight";

import type { PaginationPageButtonProps } from "./Pagination.types";
import { PREFETCH_REACTIVATE_MS } from "./constants";

export function PaginationPageButton({
  page,
  current,
  size,
  disabled,
  onPageChange,
  onPagePrefetch,
}: PaginationPageButtonProps): JSX.Element {
  const { elementRef, onFocus } = useForesight<HTMLButtonElement>({
    name: `Pagination page ${page}`,
    reactivateAfter: PREFETCH_REACTIVATE_MS,
    callback:
      onPagePrefetch && !disabled ? () => onPagePrefetch(page) : undefined,
  });

  return (
    <Button
      ref={elementRef}
      onFocus={onFocus}
      size={size}
      variant={current ? "primary" : "ghost"}
      disabled={disabled}
      aria-current={current ? "page" : undefined}
      onClick={() => onPageChange(page)}
    >
      {page}
    </Button>
  );
}
